<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <b-col style="padding-left: 0px;">
      <norm-scale-table :normScales="scalesModified" :onChangeSelected="onChangeSelected" />
      <b-form-group class="mt-2">
        <b-button type="submit" class="me-1" :disabled="submitting" @click="beforeSaving(false)">{{ $t('save') }} <i v-if="submitting" class="fa fa-spinner fa-pulse"></i></b-button>
        <b-button type="reset" variant="danger" :disabled="submitting">{{ $t('cancel') }}</b-button>
      </b-form-group>
    </b-col>
  </b-form>
</template>

<script>
import normScaleTable from './normscaletable'
import { mapActions } from 'vuex'

export default {
  name: 'norm-scale-selector',
  props: [
    'normScales',
    'currentTestMethod',
    'selectedCulture',
    'defaultCulture'
  ],
  components: {
    normScaleTable
  },
  computed: {
    submitMessage() {
      return this.$t('save_ok_feedback')
    }
  },
  data() {
    return {
      scalesModified: this.normScales || [],
      submitting: false
    }
  },
  watch: {
    normScales() {
      this.scalesModified = this.normScales
    }
  },
  methods: {
    ...mapActions({
      showErrorMessage: 'showErrorMessage',
      showSuccessMessage: 'showSuccessMessage'
    }),
    ...mapActions('testMethodsModule', {
      updateNormScales: 'updateNormScales',
      getTestMethod: 'getTestMethod'
    }),
    beforeSaving(doRandomize) {
      this.doRandomize = doRandomize
    },
    onChangeSelected: function(scale) {
      const newScales = this.scalesModified.map(i => {
        if (i.normGroupScaleValueId === scale.normGroupScaleValueId) {
          return { ...i, selected: !scale.selected }
        }
        return i
      })
      this.scalesModified = newScales
    },
    onSubmit() {
      this.submitting = true
      let normScaleIds = this.scalesModified
        .filter(scale => scale.selected)
        .map(selectedScale => selectedScale.normGroupScaleValueId)
      this.updateNormScales({
        testMethodId: this.currentTestMethod.id,
        normScaleIds,
        languageId: this.selectedCulture.languageId,
        defaultLanguageId: this.defaultCulture.languageId,
        doRandomize: this.doRandomize
      })
        .then(() => {
          this.getTestMethod({
            testMethodId: this.currentTestMethod.id,
            languageId: this.selectedCulture.languageId
          })
          this.showSuccessMessage(this.$t('save_ok_feedback'))
          this.submitting = false
        })
        .catch(error => {
          this.showErrorMessage(error)
          this.submitting = false
        })
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
button .fa-spinner {
  margin-left: 5px;
  color: #ffffff;
}
</style>
